import React from "react";
import log from "cslog";
import Element from "../ElementStaticView";
// import { parseStyle } from "../../../../parser/parserResponsive";
// import { tablet, mobile } from "../../../../data/bp";
import { parseStyle, tablet, mobile, isHidden } from "../../../juntion";
import SectionWrapper from "./wrappers/SectionWrapper";
import styles from "./wrappers/styles/LayoutWrapper.module.scss";
import { DEFAULT_PADDING_CORRECTION_IN_MARGIN } from "../../../junctionAbs";

function Section({ id, db, dydb, gs, ctx, device, index, wrapperProps = {},
	page_dims_inner = {},
	is_document = false }) {
	const data = db[id];

	const ps = parseStyle(data, gs, data.cstate);

	if (isHidden(ps.classes, device)) {
		return null;
	}

	let input = ps.input;
	input = { ...input, ...(tablet(device) && ps.itablet) };
	input = { ...input, ...(mobile(device) && ps.imobile) };

	let widths = input.widths;
	if (input.orientation === "v") {
		widths = new Array(widths.length).fill(100);
	}

	const colStyle = {
		// padding: "1px",
		paddingBottom: input.orientation === "v" ? input.gapBetweenChilds : 0,
	};

	const pageMaxWidth = gs.config.pageMaxWidth || 1080;

	// ==============
	const gap = input.gapBetweenChilds / 4 || 0;
	const gapPerChild = (gap * (data.childs.length - 1)) / data.childs.length;

	let newWidths = input.widths.map((w) => w - gapPerChild);
	if (input.orientation === "v") {
		newWidths = new Array(input.widths.length).fill(100);
	}

	// let width = themePage.pageMaxWidth;
	let width = "100%";
	let maxWidth = pageMaxWidth;
	let margin = "0px auto";
	if (input.sectionWidth?.type === "full") {
		width = "100%";
		maxWidth = "100%";
	} else if (input.sectionWidth?.type === "custom") {
		maxWidth = "100%";
		width = input.sectionWidth?.value;
	}

	let children = data.childs;

	return (
		<SectionWrapper
			data={data}
			input={input}
			index={index}
			ps={ps}
			gs={gs}
			device={device}
			{...wrapperProps}
		>
			{/* <div
				style={{
					margin: "0px auto",
					zIndex: input.zIndex,
					width: width,
					height: "auto",
					maxWidth: maxWidth,
				}}
			> */}
			<SectionSizeWrapper
				children={children}
				index={index}
				input={input}
				width={width}
				maxWidth={maxWidth}
				margin={margin}
				deviceName={device}
				is_document={is_document}
				page_dims_inner={page_dims_inner}
				is_full={input.sectionWidth?.type === "full"}
			>
				<div
					style={{
						width: "100%",
						height: "100%",
						display: "flex",
						justifyContent: "center",
						alignItems: input.alignChilds,
						zIndex: input.zIndex,
					}}
				>
					{/* <Element id={data.child} device={device} gs={gs} /> */}

					<div
						className={styles.wrapper}
						style={{
							gap: `${gap}%`,
							// flexDirection: input.reverseOrder
							//     ? "row-reverse"
							//     : "row",
						}}
					>
						{children.map((item, index) => {
							return (
								<div
									key={index}
									style={{
										...colStyle,
										paddingBottom:
											index === children.length - 1
												? 0
												: colStyle.paddingBottom,
										// width: `${widths[index]}%`,
										width: `${newWidths[index]}%`,
										height: "auto",
										maxWidth: "100%",
									}}
								>
									<Element
										key={item}
										id={item}
										db={db}
										dydb={dydb}
										index={index}
										device={device}
										gs={gs}
										ctx={ctx}
									/>
								</div>
							);
						})}
					</div>
				</div>
			</SectionSizeWrapper>
			{/* </div> */}
		</SectionWrapper>
	);
}

export default Section;


function SectionSizeWrapper({ children, index, margin, input, width, maxWidth, deviceName, is_document = false, page_dims_inner = {}, is_full }) {
	if (is_document) {
		maxWidth = "100%";
		if (!is_full) {
			width = page_dims_inner.width || "100%";
			margin = `0px ${page_dims_inner?.margin?.right - DEFAULT_PADDING_CORRECTION_IN_MARGIN}px 0px ${page_dims_inner?.margin?.left - DEFAULT_PADDING_CORRECTION_IN_MARGIN}px`
		}
	}

	// log.d(page_dims_inner, "page_dims_inner in SectionSizeWrapper");
	// log.d(width, "Width in SectionSizeWrapper");
	// log.d(margin, "Final margin in SectionSizeWrapper");

	return <div style={{
		// margin: "0px auto",
		margin: margin,
		zIndex: input.zIndex,
		width: width,
		height: "auto",
		maxWidth: maxWidth,
	}}>
		{children}
	</div>

}